<template>
  <div class="layout">
    <div class="layout-header" :class="{ fixed: fixed }">
      <LayoutHeader />
    </div>
    <div class="layout-main">
      <router-view />
    </div>
    <div class="layout-footer">
      <LayoutFooter />
    </div>
    <!-- <div class="feedback-btn" @click="dialogVisible = true">
      <i class="el-icon-service"></i>
    </div> -->
    <el-dialog
      title="意见反馈"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-input
        type="textarea"
        maxlength="200"
        :rows="6"
        placeholder="留下你的意见"
        v-model="content"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import LayoutHeader from "./header";
import LayoutHeader from "./head.vue";
import LayoutFooter from "./footer";
import { mapActions } from "vuex";
export default {
  name: "layout",
  components: {
    LayoutHeader,
    LayoutFooter
  },
  data() {
    return {
      dialogVisible: false,
      content: ""
    };
  },
  computed: {
    fixed() {
      const path = this.$route.path;
      const arr = ["/job/detail", "/weapp"];
      return arr.indexOf(path) > -1;
    }
  },
  methods: {
    ...mapActions(["feedBack"]),
    handleClose() {
      this.dialogVisible = false;
    },
    submit() {
      if (this.content == "") return;
      this.feedBack(this.content).then(() => {
        this.$message.success("反馈成功");
        this.dialogVisible = false;
      });
    },
    openPublishPositionWeb() {
      window.open("http://selfhelp.itneituiquan.com", "_blank");
    }
  }
};
</script>

<style lang="less">
.feedback-btn {
  font-size: 1.3rem;
  color: #007fff;
  margin: 1rem 0 0;
  padding: 0;
  width: 3.33rem;
  height: 3.33rem;
  line-height: 1;
  background-color: #fff;
  border: 1px solid #f1f1f1;
  border-radius: 50%;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  position: fixed;
  right: 2rem;
  bottom: 2rem;
  z-index: 1000;
  i {
    margin: 17px;
  }
}
.layout {
  &-header {
    background-color: #fff;
    z-index: 999;
    &.fixed {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
    }
  }
  &-main {
    min-height: 600px;
    margin: 66px auto 0 ;
    background: linear-gradient(360deg, #F9FBFF 0%, #DCEAFF 100%);
  }
  &-footer {
    background-color: #fff;
  }
  .publish-position {
    position: fixed;
    right: 1px;
    bottom: 6rem;
    z-index: 1000;
    word-wrap: break-word;

    .img {
      vertical-align: middle;
      margin-right: 0px;
      display: inline-block;
      height: 36px;
    }
  }
}
</style>
